import request from '../request';
import config from '@/config/index'
const { apiPath } = config

// 获取基础数据
export const getBasedata = params => {
	return request({
		url: `${apiPath()}/getAllData`,
		method: 'get',
		params: {
			...params,
			t: Date.now()
		}
	});
};


// 下载数据
export const downloadFile = () => {
	return request({
		url: `${apiPath()}/download`,
		method: 'get',
		// 不设置流模式，会乱码
		responseType: 'arraybuffer',
		params: {
			noMessage: {
				download: 1
			}
		}
	});
};

// 新增、更新多因子策略
export const setFactorStrategie = data => {
	return request({
		url: `${apiPath('api')}/factor/set`,
		method: 'post',
		data:{
			...data,
			noMessage: {
				noFail: true,   // 错误不提示
				noLoading: 1,
				// noSuccess: 1,
			}
		}
	});
};


// 获取多因子策略
export const getFactorList = data => {
	return request({
		url: `${apiPath('api')}/factor/check`,
		method: 'post',
		data:{
			...data,
			noMessage: {
				noLoading: 1,
				noSuccess: 1,
			}
		}
	});
};
